var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-spin", { attrs: { size: "large", spinning: _vm.loading } }, [
    _c("div", { staticClass: "home" }, [
      _vm.$route.query.expried == "1"
        ? _c("div", { staticClass: "tips" }, [
            _c(
              "div",
              { staticClass: "tips-cont", class: [_vm.lang] },
              [
                _c("a-icon", {
                  staticClass: "icon",
                  style: { marginLeft: _vm.lang == "AR" ? "10px" : "0px" },
                  attrs: { type: "exclamation-circle" },
                }),
                _vm._v(_vm._s(_vm.$t("freeTrialTips")) + " "),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "wrap-step" },
        [
          _c("Step", {
            attrs: {
              current: _vm.$route.query.isfromCamp == 1 ? 1 : 0,
              isfromCamp: _vm.$route.query.isfromCamp == 1 ? true : false,
            },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "wrap pricing", class: [_vm.lang] }, [
        _c("div", { staticClass: "pricing_container" }, [
          _c("div", { staticClass: "chooseTips" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("Choosetheright"))),
            ]),
            _c("div", { staticClass: "subTi" }, [
              _vm._v(" " + _vm._s(_vm.$t("publishyourcampaign")) + " "),
            ]),
          ]),
          _c("div", { staticClass: "baozhang" }, [
            _c(
              "p",
              { staticClass: "t1" },
              [
                _c("a-icon", {
                  staticClass: "icon",
                  attrs: { type: "safety-certificate" },
                }),
                _vm._v(" " + _vm._s(_vm.$t("fourMoth"))),
                _c(
                  "a-tooltip",
                  {
                    attrs: {
                      placement: "bottom",
                      overlayClassName: "customTip",
                    },
                  },
                  [
                    _c("template", { slot: "title" }, [
                      _c("p", { staticStyle: { "font-size": "12px" } }, [
                        _vm._v(" " + _vm._s(_vm.$t("Termsandconditionsapply"))),
                        _c("br"),
                        _vm._v(
                          " • " + _vm._s(_vm.$t("Aleast10campaigns")) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          " • " + _vm._s(_vm.$t("Atleasttwocampaigns")) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          " • " + _vm._s(_vm.$t("Noleadsweregenerated")) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          " • " + _vm._s(_vm.$t("Thispolicyapplies")) + " "
                        ),
                      ]),
                    ]),
                    _c(
                      "span",
                      [
                        _c("a-icon", {
                          staticStyle: { color: "#fff", "margin-left": "5px" },
                          attrs: { type: "exclamation-circle" },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c("p", {
              staticClass: "t2",
              domProps: { innerHTML: _vm._s(_vm.formatEmail2()) },
            }),
          ]),
          _c("div", { staticClass: "wrap-btn" }, [
            _c("div", { staticClass: "pricing_monthly" }, [
              _c(
                "div",
                {
                  staticClass: "pricing_monthlyopan",
                  class: { active: _vm.active },
                  staticStyle: { direction: "ltr" },
                },
                [
                  _c(
                    "span",
                    {
                      class: _vm.lang,
                      on: {
                        click: function ($event) {
                          return _vm.tabHandler()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Monthly")))]
                  ),
                  _c(
                    "span",
                    {
                      class: _vm.lang,
                      on: {
                        click: function ($event) {
                          return _vm.tabHandler()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Annually")))]
                  ),
                ]
              ),
            ]),
            _c("div", { staticClass: "enterprise-header" }, [
              _c("h2", { class: [_vm.lang] }, [
                _vm._v(" StrategyBrain "),
                _c("span", { staticClass: "enterprise-badge" }, [
                  _vm._v(_vm._s(_vm.$t("Enterprise"))),
                ]),
              ]),
            ]),
          ]),
          _c(
            "div",
            {
              staticClass: "main-wrap",
              class: {
                incluedFree: _vm.planList.length && _vm.planList[0].length == 5,
              },
            },
            [
              _c("div", { staticClass: "left-box" }, [
                _c("div", { staticClass: "pric_switchingall" }, [
                  _c(
                    "div",
                    {
                      staticClass: "pric_switchingitem",
                      class: { show: _vm.active },
                      attrs: { title: "Monthly" },
                    },
                    [
                      _c("div", { staticClass: "pric_switchinglist" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "price_swlistitem price_swlistitemlie1",
                            staticStyle: { display: "none" },
                            style: {
                              marginRight: _vm.lang == "AR" ? 0 : "16px",
                            },
                          },
                          [
                            _c("div", { staticClass: "priceitemtop" }, [
                              _c("h2", { staticClass: "priceitemtop_title" }, [
                                _vm._v(_vm._s(_vm.$t("Manual"))),
                              ]),
                              _c("div", { staticClass: "priceitemtop_desc" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ReducecostsandImprove")) +
                                    " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_price" },
                                [
                                  _c("b", [_vm._v("$")]),
                                  _c("big", [_vm._v("5000")]),
                                  _c("span", [
                                    _vm._v(
                                      "/" +
                                        _vm._s(
                                          _vm.lang == "US"
                                            ? "monthly"
                                            : _vm.$t("Monthly")
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "priceitembottom" }, [
                              _c("div", { staticClass: "priceitem_content" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("40hoursofworkperweek"))
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("ClientsAndCandidatesNeed")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("EachClientAndCandidate")) +
                                      " "
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("DelayedresponsesMakeTimely")
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm.planList.length && _vm.planList[0].length == 5
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "price_swlistitem price_swlistitemlie2",
                              },
                              [
                                _c("div", { staticClass: "priceitemtop" }, [
                                  _c(
                                    "h2",
                                    { staticClass: "priceitemtop_title" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("FreeTrial")) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "priceitemtop_desc",
                                      staticStyle: { color: "#0e756a" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Bindyourcreditcard")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_price" },
                                    [
                                      _c("b", [_vm._v("$")]),
                                      _c("big", [_vm._v("0")]),
                                      _c("span", [
                                        _vm._v(
                                          "/" + _vm._s(_vm.$t("FirstWeek"))
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_botselect" },
                                    [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(_vm.$t("Botselection")) + "："
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "priceitembottom" }, [
                                  _c("div", { staticClass: "price_conswich" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "price_conswichitem price_conswichitemqh",
                                        class: { show: !_vm.switchActive },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "priceitem_content" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("CoreFeature")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "AllcorefeaturesofAISalesRep"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Campaign")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(" 1 "),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("SearchResults")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(" 33 "),
                                            ]),
                                            _c(
                                              "p",
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ConnectionRequest"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _c(
                                                  "a-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "topLeft",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("landTips")
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" 30 "),
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        margin: "0 5px",
                                                      },
                                                      attrs: {
                                                        type: "exclamation-circle",
                                                      },
                                                    }),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "p",
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Conversation")
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _c(
                                                  "a-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "topLeft",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("landTips")
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" 50"),
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        margin: "0 5px",
                                                      },
                                                      attrs: {
                                                        type: "exclamation-circle",
                                                      },
                                                    }),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("DashBoard")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("Notsupported")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("HRExpert")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("Fullysupported")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "price_conswichitem price_conswichitemqh",
                                        class: { show: _vm.switchActive },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "priceitem_content" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("CoreFeature")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("AllcoreAIRecruiter")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Campaign")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(" 1 "),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("SearchResults")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(" 33 "),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("ConnectionRequest")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " 30/" +
                                                  _vm._s(_vm.$t("Monthly")) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Connection")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(" 27 "),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Conversation")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(" 50 "),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("DashBoard")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("Notsupported")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("HRExpert")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("Fullysupported")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_getbtnflex" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "priceitemtop_getbtn" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0)",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.pay(
                                                    _vm.planList[1][4],
                                                    4
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Continuetrial"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "price_swlistitem price_swlistitemlie3",
                          },
                          [
                            _c("div", { staticClass: "priceitemtop" }, [
                              _c("h2", { staticClass: "priceitemtop_title" }, [
                                _vm._v(_vm._s(_vm.$t("LitePlan"))),
                              ]),
                              _vm.planList[0] && _vm.planList[0][1]
                                ? _c("div", {
                                    staticClass: "priceitemtop_desc",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm
                                          .$t("ChooseEitherAISale100")
                                          .replace(
                                            "40",
                                            _vm.planList[0][1]
                                              .max_connection_num
                                          )
                                          .replace(
                                            "100",
                                            _vm.planList[0][1]
                                              .max_conversation_num
                                          )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_price" },
                                [
                                  _c("b", [_vm._v("US $")]),
                                  _c("big", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.planList[0] && _vm.planList[0][1]
                                          ? _vm.planList[0] &&
                                              _vm.planList[0][1].price
                                          : "0"
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("/" + _vm._s(_vm.$t("month"))),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "priceitemtop_dally" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("paidMonthly")) + " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_botselect" },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Botselection")) + "："
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "priceitembottom" }, [
                              _c("div", { staticClass: "price_conswich" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price_conswichitem price_conswichitemqh",
                                    class: { show: !_vm.switchActive },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " All core " +
                                              _vm._s(
                                                _vm.$t(
                                                  "AllcorefeaturesofAISalesRep"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 80/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  { class: [_vm.lang] },
                                                  [
                                                    _vm._v(
                                                      " 100/" +
                                                        _vm._s(
                                                          _vm.$t("monthly2")
                                                        )
                                                    ),
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        margin: "0 5px",
                                                      },
                                                      attrs: {
                                                        type: "exclamation-circle",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price_conswichitem price_conswichitemqh",
                                    class: { show: _vm.switchActive },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("AllcoreAIRecruiter")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 80/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 100/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_getbtnflex" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_getbtn" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.pay(
                                                _vm.planList[0][1],
                                                1
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Purchase1")))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "price_swlistitem price_swlistitemlie4",
                          },
                          [
                            _c("div", { staticClass: "pricehot" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("besetSeller"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "priceitemtop" }, [
                              _c("h2", { staticClass: "priceitemtop_title" }, [
                                _vm._v(_vm._s(_vm.$t("ProPlan"))),
                              ]),
                              _vm.planList[0] && _vm.planList[0][2]
                                ? _c("div", {
                                    staticClass: "priceitemtop_desc",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm
                                          .$t("ChooseEitherAISale500")
                                          .replace(
                                            "120",
                                            _vm.planList[0][2]
                                              .max_connection_num
                                          )
                                          .replace(
                                            "500",
                                            _vm.planList[0][2]
                                              .max_conversation_num
                                          )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_price" },
                                [
                                  _c("b", [_vm._v("US $")]),
                                  _c("big", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.planList[0] && _vm.planList[0][2]
                                          ? _vm.planList[0] &&
                                              _vm.planList[0][2].price
                                          : "0"
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("/" + _vm._s(_vm.$t("month"))),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "priceitemtop_dally" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("paidMonthly")) + " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_botselect" },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Botselection")) + "："
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "priceitembottom" }, [
                              _c("div", { staticClass: "price_conswich" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price_conswichitem price_conswichitemqh",
                                    class: { show: !_vm.switchActive },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "AllcorefeaturesofAISalesRep"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 240/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 500/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price_conswichitem price_conswichitemqh",
                                    class: { show: _vm.switchActive },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("AllcoreAIRecruiter")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 240/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 500/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_getbtnflex" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_getbtn" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.pay(
                                                _vm.planList[0][2],
                                                2
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Purchase1")))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "price_swlistitem price_swlistitemlie5",
                            style: {
                              marginRight: _vm.lang == "AR" ? "16px" : "0px",
                            },
                          },
                          [
                            _c("div", { staticClass: "priceitemtop" }, [
                              _c("h2", { staticClass: "priceitemtop_title" }, [
                                _vm._v(" " + _vm._s(_vm.$t("PrimePlan")) + " "),
                              ]),
                              _c("div", {
                                staticClass: "priceitemtop_desc",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("GainunlimitedAccess")
                                  ),
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_price" },
                                [
                                  _c("b", [_vm._v("US $")]),
                                  _c("big", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.planList[0] && _vm.planList[0][3]
                                          ? _vm.planList[0] &&
                                              _vm.planList[0][3].price
                                          : "0"
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("/" + _vm._s(_vm.$t("month"))),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "priceitemtop_dally" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("paidMonthly")) + " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_botselect" },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Botselection")) + "："
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_botflex" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "priceitemtop_botflexitem noclick",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "prbot_label" },
                                            [_vm._v(_vm._s(_vm.$t("Sales")))]
                                          ),
                                          _c("span", {
                                            staticClass: "prbot_button",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "priceitemtop_botflexitem noclick",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "prbot_label" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Recruiter"))
                                              ),
                                            ]
                                          ),
                                          _c("span", {
                                            staticClass: "prbot_button",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "priceitembottom" }, [
                              _c("div", { staticClass: "price_conswich" }, [
                                _c(
                                  "div",
                                  { staticClass: "price_conswichitem show" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ": "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#0e756a",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Allfeatures"))
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _vm._v(
                                                  " 480/" +
                                                    _vm._s(_vm.$t("monthly2")) +
                                                    " "
                                                ),
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                    color: "#0e756a",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Unlimited")) +
                                                " "
                                            ),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                    color: "#0e756a",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "price_conswichitem" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Allfeatures")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Unlimited")) +
                                                " "
                                            ),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                    color: "#0e756a",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Unlimited")) +
                                                " "
                                            ),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                    color: "#0e756a",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_getbtnflex" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_getbtn" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.pay(
                                                _vm.planList[0][3],
                                                3
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Purchase1")))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "pric_switchingitem",
                      class: { show: !_vm.active },
                      attrs: { title: "Annually" },
                    },
                    [
                      _c("div", { staticClass: "pric_switchinglist" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "price_swlistitem price_swlistitemlie1",
                            staticStyle: { display: "none" },
                            style: {
                              marginRight: _vm.lang == "AR" ? 0 : "16px",
                            },
                          },
                          [
                            _c("div", { staticClass: "priceitemtop" }, [
                              _c("h2", { staticClass: "priceitemtop_title" }, [
                                _vm._v(_vm._s(_vm.$t("Manual"))),
                              ]),
                              _c("div", { staticClass: "priceitemtop_desc" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("ReducecostsandImprove")) +
                                    " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_price" },
                                [
                                  _c("b", [_vm._v("$")]),
                                  _c("big", [_vm._v("5000")]),
                                  _c("span", [
                                    _vm._v(
                                      "/" +
                                        _vm._s(
                                          _vm.lang == "US"
                                            ? "monthly"
                                            : _vm.$t("Monthly")
                                        )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "priceitembottom" }, [
                              _c("div", { staticClass: "priceitem_content" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(_vm.$t("40hoursofworkperweek"))
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("ClientsAndCandidatesNeed")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("EachClientAndCandidate")) +
                                      " "
                                  ),
                                ]),
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("DelayedresponsesMakeTimely")
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm.planList.length && _vm.planList[1].length == 5
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "price_swlistitem price_swlistitemlie2",
                              },
                              [
                                _c("div", { staticClass: "priceitemtop" }, [
                                  _c(
                                    "h2",
                                    { staticClass: "priceitemtop_title" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("FreeTrial")) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "priceitemtop_desc",
                                      staticStyle: { color: "#0e756a" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Bindyourcreditcard")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_price" },
                                    [
                                      _c("b", [_vm._v("$")]),
                                      _c("big", [_vm._v("0")]),
                                      _c("span", [
                                        _vm._v(
                                          "/" + _vm._s(_vm.$t("FirstWeek"))
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_botselect" },
                                    [
                                      _c("h3", [
                                        _vm._v(
                                          _vm._s(_vm.$t("Botselection")) + "："
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "priceitembottom" }, [
                                  _c("div", { staticClass: "price_conswich" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "price_conswichitem price_conswichitemqh",
                                        class: { show: !_vm.switchActive },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "priceitem_content" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("CoreFeature")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "AllcorefeaturesofAISalesRep"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Campaign")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(" 1 "),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("SearchResults")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(" 33 "),
                                            ]),
                                            _c(
                                              "p",
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ConnectionRequest"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _c(
                                                  "a-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "topLeft",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("landTips")
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" 30 "),
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        margin: "0 5px",
                                                      },
                                                      attrs: {
                                                        type: "exclamation-circle",
                                                      },
                                                    }),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "p",
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Conversation")
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _c(
                                                  "a-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "topLeft",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("landTips")
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" 50"),
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        margin: "0 5px",
                                                      },
                                                      attrs: {
                                                        type: "exclamation-circle",
                                                      },
                                                    }),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("DashBoard")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("Notsupported")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("HRExpert")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("Fullysupported")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "price_conswichitem price_conswichitemqh",
                                        class: { show: _vm.switchActive },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "priceitem_content" },
                                          [
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("CoreFeature")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("AllcoreAIRecruiter")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Campaign")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(" 1 "),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("SearchResults")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(" 33 "),
                                            ]),
                                            _c(
                                              "p",
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "ConnectionRequest"
                                                      )
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _c(
                                                  "a-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "topLeft",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("landTips")
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " 30/" +
                                                        _vm._s(
                                                          _vm.$t("monthly2")
                                                        )
                                                    ),
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        margin: "0 5px",
                                                      },
                                                      attrs: {
                                                        type: "exclamation-circle",
                                                      },
                                                    }),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "p",
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("Conversation")
                                                    ) + ":"
                                                  ),
                                                ]),
                                                _c(
                                                  "a-tooltip",
                                                  {
                                                    attrs: {
                                                      placement: "topLeft",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "template",
                                                      { slot: "title" },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("landTips")
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(
                                                      " 50/" +
                                                        _vm._s(
                                                          _vm.$t("monthly2")
                                                        )
                                                    ),
                                                    _c("a-icon", {
                                                      staticStyle: {
                                                        margin: "0 5px",
                                                      },
                                                      attrs: {
                                                        type: "exclamation-circle",
                                                      },
                                                    }),
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("DashBoard")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("Notsupported")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                            _c("p", [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("HRExpert")) +
                                                    ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("Fullysupported")
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_getbtnflex" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "priceitemtop_getbtn" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0)",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.pay(
                                                    _vm.planList[0][4],
                                                    4
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Continuetrial"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass:
                              "price_swlistitem price_swlistitemlie3",
                          },
                          [
                            _c("div", { staticClass: "priceitemtop" }, [
                              _c("h2", { staticClass: "priceitemtop_title" }, [
                                _vm._v(_vm._s(_vm.$t("LitePlan"))),
                              ]),
                              _vm.planList[1] && _vm.planList[1][1]
                                ? _c("div", {
                                    staticClass: "priceitemtop_desc",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm
                                          .$t("litePlanDes")
                                          .replace(
                                            "99",
                                            _vm.planList[1][1].price
                                          )
                                          .replace(
                                            "40",
                                            _vm.planList[1][1]
                                              .max_connection_num
                                          )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_price" },
                                [
                                  _c("b", [_vm._v("US $")]),
                                  _c("big", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.planList[1] && _vm.planList[1][1]
                                          ? _vm.computedPrice(
                                              _vm.planList[1][1].price
                                            )
                                          : 0
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("/" + _vm._s(_vm.$t("month"))),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "priceitemtop_dally" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("paidAnnually")) + " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_botselect" },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Botselection")) + "："
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "priceitembottom" }, [
                              _c("div", { staticClass: "price_conswich" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price_conswichitem price_conswichitemqh",
                                    class: { show: !_vm.switchActive },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "AllcorefeaturesofAISalesRep"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 80/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 100/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price_conswichitem price_conswichitemqh",
                                    class: { show: _vm.switchActive },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("AllcoreAIRecruiter")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 80/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 100/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_getbtnflex" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_getbtn" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.pay(
                                                _vm.planList[1][1],
                                                1
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Purchase1")))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "price_swlistitem price_swlistitemlie4",
                          },
                          [
                            _c("div", { staticClass: "pricehot" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("besetSeller"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "priceitemtop" }, [
                              _c("h2", { staticClass: "priceitemtop_title" }, [
                                _vm._v(_vm._s(_vm.$t("ProPlan"))),
                              ]),
                              _vm.planList[1] && _vm.planList[1][2]
                                ? _c("div", {
                                    staticClass: "priceitemtop_desc",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm
                                          .$t("proPlanDes")
                                          .replace(
                                            "399",
                                            _vm.planList[1][2].price
                                          )
                                          .replace(
                                            "120",
                                            _vm.planList[1][2]
                                              .max_connection_num
                                          )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_price" },
                                [
                                  _c("b", [_vm._v("US $")]),
                                  _c("big", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.planList[1] && _vm.planList[1][2]
                                          ? _vm.computedPrice(
                                              _vm.planList[1][2].price
                                            )
                                          : 0
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("/" + _vm._s(_vm.$t("month"))),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "priceitemtop_dally" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("paidAnnually")) + " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_botselect" },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Botselection")) + "："
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "priceitembottom" }, [
                              _c("div", { staticClass: "price_conswich" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price_conswichitem price_conswichitemqh",
                                    class: { show: !_vm.switchActive },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "AllcorefeaturesofAISalesRep"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 240/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 500/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "price_conswichitem price_conswichitemqh",
                                    class: { show: _vm.switchActive },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("AllcoreAIRecruiter")
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 240/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(
                                                  " 500/" +
                                                    _vm._s(_vm.$t("monthly2"))
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_getbtnflex" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_getbtn" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.pay(
                                                _vm.planList[1][2],
                                                2
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Purchase1")))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "price_swlistitem price_swlistitemlie5",
                            style: {
                              marginRight: _vm.lang == "AR" ? "16px" : "0px",
                            },
                          },
                          [
                            _c("div", { staticClass: "priceitemtop" }, [
                              _c("h2", { staticClass: "priceitemtop_title" }, [
                                _vm._v(" " + _vm._s(_vm.$t("PrimePlan")) + " "),
                              ]),
                              _vm.planList[1] && _vm.planList[1][3]
                                ? _c("div", {
                                    staticClass: "priceitemtop_desc",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm
                                          .$t("primePlanDes")
                                          .replace(
                                            "799",
                                            _vm.planList[1][3].price
                                          )
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_price" },
                                [
                                  _c("b", [_vm._v("US $")]),
                                  _c("big", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.planList[1] && _vm.planList[1][3]
                                          ? _vm.computedPrice(
                                              _vm.planList[1][3].price
                                            )
                                          : 0
                                      )
                                    ),
                                  ]),
                                  _c("span", [
                                    _vm._v("/" + _vm._s(_vm.$t("month"))),
                                  ]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "priceitemtop_dally" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("paidAnnually")) + " "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_botselect" },
                                [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.$t("Botselection")) + "："
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_botflex" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "priceitemtop_botflexitem noclick",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "prbot_label" },
                                            [_vm._v(_vm._s(_vm.$t("Sales")))]
                                          ),
                                          _c("span", {
                                            staticClass: "prbot_button",
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "priceitemtop_botflexitem noclick",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "prbot_label" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Recruiter"))
                                              ),
                                            ]
                                          ),
                                          _c("span", {
                                            staticClass: "prbot_button",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _c("div", { staticClass: "priceitembottom" }, [
                              _c("div", { staticClass: "price_conswich" }, [
                                _c(
                                  "div",
                                  { staticClass: "price_conswichitem show" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ": "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#0e756a",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("Allfeatures"))
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _vm._v(
                                                  " 480/" +
                                                    _vm._s(_vm.$t("monthly2")) +
                                                    " "
                                                ),
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                    color: "#0e756a",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " + _vm._s(_vm.$t("Unlimited"))
                                            ),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                    color: "#0e756a",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "price_conswichitem" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "priceitem_content" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("CoreFeature")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Allfeatures")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("Campaign")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("SearchResults")) +
                                                ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Unlimited")) +
                                              " "
                                          ),
                                        ]),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("ConnectionRequest")
                                                ) + ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Unlimited")) +
                                                " "
                                            ),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                    color: "#0e756a",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "p",
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(_vm.$t("Conversation")) +
                                                  ":"
                                              ),
                                            ]),
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.$t("Unlimited")) +
                                                " "
                                            ),
                                            _c(
                                              "a-tooltip",
                                              {
                                                attrs: { placement: "topLeft" },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "title" },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("landTips")
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _c("a-icon", {
                                                  staticStyle: {
                                                    margin: "0 5px",
                                                    color: "#0e756a",
                                                  },
                                                  attrs: {
                                                    type: "exclamation-circle",
                                                  },
                                                }),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("DashBoard")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(_vm.$t("HRExpert")) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Fullysupported")) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Proxycoverage")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("Languagesupport")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIConversationTuning")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t(
                                                    "SimulatedConversationTesting"
                                                  )
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[0]
                                              ) + ":"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .$t("AIRequirementsAnalysis")
                                                  .split(":")[1]
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "priceitemtop_getbtnflex" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "priceitemtop_getbtn" },
                                    [
                                      _c(
                                        "a",
                                        {
                                          attrs: { href: "javascript:void(0)" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.pay(
                                                _vm.planList[1][3],
                                                3
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Purchase1")))]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c(
                "div",
                {
                  staticClass: "price_swlistitem right-box",
                  class: [_vm.lang],
                },
                [
                  _c("h4", [_vm._v(_vm._s(_vm.$t("EnterprisePlan")))]),
                  _c(
                    "div",
                    {
                      staticClass: "enterprise-description",
                      class: [_vm.lang],
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("Seamlesslyboost")) + " ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "plan-selector", class: [_vm.lang] },
                    [
                      _c("div", { staticClass: "plan-selector-title" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("ChooseYourTeamSize")) + " "
                        ),
                      ]),
                      _c("div", { staticClass: "plan-buttons" }, [
                        _c(
                          "button",
                          {
                            staticClass: "plan-option-btn",
                            class: { active: _vm.currentIndex == 1 },
                            attrs: { "data-plan": "starter" },
                            on: {
                              click: function ($event) {
                                return _vm.updateContactEmail(
                                  "Starter",
                                  "3 accounts",
                                  1
                                )
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "plan-option-name" }, [
                              _vm._v(_vm._s(_vm.$t("Starter"))),
                            ]),
                            _c("div", { staticClass: "plan-option-accounts" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("accounts").replace("*", 3)) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "plan-option-btn recommended",
                            class: { active: _vm.currentIndex == 2 },
                            attrs: { "data-plan": "growth" },
                            on: {
                              click: function ($event) {
                                return _vm.updateContactEmail(
                                  "Growth",
                                  "10 accounts",
                                  2
                                )
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "plan-option-name" }, [
                              _vm._v(_vm._s(_vm.$t("Growth"))),
                            ]),
                            _c("div", { staticClass: "plan-option-accounts" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("accounts").replace("*", 10)) +
                                  " "
                              ),
                            ]),
                            _c("span", { staticClass: "popular" }, [
                              _vm._v("🔥 " + _vm._s(_vm.$t("popular"))),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "plan-option-btn",
                            class: { active: _vm.currentIndex == 3 },
                            attrs: { "data-plan": "scale" },
                            on: {
                              click: function ($event) {
                                return _vm.updateContactEmail(
                                  "Scale",
                                  "25 accounts",
                                  3
                                )
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "plan-option-name" }, [
                              _vm._v(_vm._s(_vm.$t("Scale"))),
                            ]),
                            _c("div", { staticClass: "plan-option-accounts" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("accounts").replace("*", 25)) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass: "plan-option-btn",
                            class: { active: _vm.currentIndex == 4 },
                            attrs: { "data-plan": "enterprise" },
                            on: {
                              click: function ($event) {
                                return _vm.updateContactEmail(
                                  "Enterprise",
                                  "50+ accounts",
                                  4
                                )
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "plan-option-name" }, [
                              _vm._v(_vm._s(_vm.$t("Enterprise"))),
                            ]),
                            _c("div", { staticClass: "plan-option-accounts" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("accounts").replace("*", "50+")
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "features-section", class: [_vm.lang] },
                    [
                      _c("div", { staticClass: "features-title" }, [
                        _vm._v(_vm._s(_vm.$t("Corefeature"))),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "features-list collapsed",
                          class: {
                            incluedFree:
                              _vm.planList.length &&
                              _vm.planList[0].length == 5,
                            featureslist2: !(
                              _vm.planList.length && _vm.planList[0].length == 5
                            ),
                          },
                        },
                        [
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("AllFeaturesIncluded"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("EnterpriseTraining"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("EnterpriseSingle"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("AccessManagement"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("AccesstoDesignated"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("UnlimitedConnectionRequests"))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("UnlimitedConnections"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [_vm._v(_vm._s(_vm.$t("APIAccess")))]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [_vm._v(_vm._s(_vm.$t("AuditLogs")))]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("LinkedInAccess"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("MultilingualAICommunication"))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("LocalizationofSystem"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("CustomizedBusiness"))),
                            ]),
                          ]),
                          _c("div", { staticClass: "feature-item" }, [
                            _c("span", { staticClass: "feature-icon" }, [
                              _vm._v("✓"),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("TeamManagement"))),
                            ]),
                          ]),
                        ]
                      ),
                      _c("div", { staticClass: "features-toggle" }, [
                        _c(
                          "button",
                          {
                            staticClass: "features-toggle-btn",
                            on: {
                              click: function ($event) {
                                return _vm.toggleFeatures()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "toggle-text" }, [
                              _vm._v(_vm._s(_vm.$t("ShowAllFeatures"))),
                            ]),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "addons-section" }, [
                    _c("div", { staticClass: "addons-title" }, [
                      _vm._v(_vm._s(_vm.$t("Availableadd"))),
                    ]),
                    _c("div", { staticClass: "addon-item" }, [
                      _c("span", { staticClass: "addon-icon" }, [_vm._v("+")]),
                      _c("span", [_vm._v(_vm._s(_vm.$t("Warmup")))]),
                    ]),
                    _c("div", { staticClass: "addon-item" }, [
                      _c("span", { staticClass: "addon-icon" }, [_vm._v("+")]),
                      _c("span", [_vm._v(_vm._s(_vm.$t("ProxyPool")))]),
                    ]),
                    _c("div", { staticClass: "addon-item" }, [
                      _c("span", { staticClass: "addon-icon" }, [_vm._v("+")]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("Rolebasedpermissions"))),
                      ]),
                    ]),
                    _c("div", { staticClass: "addon-item" }, [
                      _c("span", { staticClass: "addon-icon" }, [_vm._v("+")]),
                      _c("span", [_vm._v(_vm._s(_vm.$t("Audittrail")))]),
                    ]),
                  ]),
                  _c("div", { staticClass: "contact-btn-wrapper" }, [
                    _c(
                      "a",
                      {
                        staticClass: "contact-btn",
                        attrs: { href: _vm.mailInfo },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Contactus")) + " ")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c("div", { staticClass: "free-trial-note" }, [
            _vm._v(" Free trials are for first-time customers only. "),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }